import { ReactElement } from 'react'
import { Layout } from '@/components/Layout'
import { Container } from '@/components/utils'
import {
  RichTextSection,
  RichTextSectionProps,
} from '@/components/patterns/RichTextSection'
import { FaqCTA, FaqCTAProps } from '@/components/patterns/FaqCTA'
import { PageMeta } from '@/src/pages'

export interface LegalPagesProps {
  meta: PageMeta
  content: RichTextSectionProps
  cta: FaqCTAProps
}
export function BaseLegalPage({
  meta,
  content,
  cta,
}: LegalPagesProps): ReactElement {
  return (
    <Layout meta={meta}>
      <Container narrow>
        <RichTextSection {...content} />
      </Container>
      <FaqCTA {...cta} />
    </Layout>
  )
}
